module.exports = __webpack_public_path__ + "img/logo.24197ef4.svg";